export default "__VITE_ASSET__3ab43215__"